<template>
  <div class="flex-grow flex flex-col w-full relative">
    <SnapshotsArea
      :snapshots="snapshots"
      :clinicianName="clinicianName"
      :user-id="$page?.props?.user?.id"
      @removeSnapshot="removeSnapshot($event)"
    />
  </div>
</template>

<script>
import { computed, watch } from 'vue';
import useSessionStore from '@/Stores/useSessionStore';
import handleAsyncRequest from '@/Utils/handleAsyncRequest';
import SnapshotsArea from '@/Components/Chat/SnapshotsArea.vue';

export default {
  props: {
    clinicianName: {
      type: String,
    },
  },
  components: { SnapshotsArea },
  setup() {
    const sessionStore = useSessionStore();
    const snapshots = computed(() => sessionStore.snapshots || []);
    const sessionId = computed(() => sessionStore.sessionDBId);

    const getSnapshots = async () => {
      const [res, err] = await handleAsyncRequest(fetchSnapshots());
      if (!err) {
        sessionStore.snapshots = res.snapshots;
      } else {
        console.error('Error fetching snapshot:', err);
      }
    };

    const fetchSnapshots = async () => {
      try {
        const res = await fetch(route('snapshot.get', { session: sessionId.value }));
        return res.json();
      } catch (error) {
        throw error.response;
      }
    };

    const deleteSnapshot = async (snapshotId) => {
      try {
        const formData = new FormData();
        formData.append('snapshot', snapshotId);

        const res = await fetch(route('snapshot.delete'), {
          method: 'POST',
          body: formData,
        });
        return res.json();
      } catch (error) {
        throw error.response;
      }
    };

    const removeSnapshot = async (snapshotId) => {
      const [res, err] = await handleAsyncRequest(deleteSnapshot(snapshotId));
      if (!err) {
        sessionStore.snapshots = res.snapshots;
      } else {
        console.error('Error of removing snapshot:', err);
      }
    };

    watch(sessionId, (newVal) => {
      if (newVal && sessionStore.isClinician) getSnapshots();
    });

    return {
      snapshots,
      getSnapshots,
      removeSnapshot,
    };
  },
};
</script>
